import React from "react";
import FuturePage from "../../../../Components/Future/index";

const Index = (props) => {
  return <FuturePage {...props} />;
};

export default Index;
